export default __webpack_public_path__ + "static/media/UploadManager_Modal.60f2f59d.svg";